import { EVENTS } from "./eventsConstants";
import { captureEvent } from "./posthog";


export const saveEvent = (event, data) => {
  captureEvent(event, data);
};

export { EVENTS };